import { render } from "./postulacion_correcta.vue?vue&type=template&id=7913ffe1"
import script from "./postulacion_correcta.vue?vue&type=script&lang=js"
export * from "./postulacion_correcta.vue?vue&type=script&lang=js"

import "./postulacion_correcta.vue?vue&type=style&index=0&id=7913ffe1&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__